































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
    AuthServiceContract,
    SignInType,
    DialogButton,
    WindowsServiceContract
} from '@/core/contracts';
import { Role, Permission } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';

@Component({})
export default class RolePermissionsEdit extends Vue {
    @Prop({ type: Object, default: null }) public role?: Role;

    public isBusy: boolean = false;

    @Inject(CONTRACTS.FetchService) private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.WindowsService) private _windowsService?: WindowsServiceContract;

    public get sortedPermissions(): Permission[] {
        return this.role!.permissions!.sort((x, y) =>
            x.code < y.code ? -1 : x.code > y.code ? 1 : 0
        );
    }

    public toggleIsAdmin(): void {
        const message: string = this.role!.isAdministrator ? 'Roles_AdminOffDialogMessage' : 'Roles_AdminOnDialogMessage';
        this._windowsService!.showDialog(localize(message), [
            { id: 1, caption: localize('DialogYes') },
            { id: 2, caption: localize('DialogCancel') }
        ]).then(id => {
            if (id === 1) {
                this.role!.isAdministrator = !this.role!.isAdministrator;
                this.callUpdateRole();
            }
        });
    }

    public togglePermission(permission: Permission): void {
        permission.enabled = !permission.enabled;
        this.callUpdateRole();
    }

    private async callUpdateRole(): Promise<void> {
        const currentContextId = ContextsState.currentContextId;
        await this._fetchService!.put<Role>(
            '/contexts/' + currentContextId + '/roles/' + this.role!.id,
            this.role
        );
    }
}
